import ArticleLayout from "@/pages/articles/components/ArticleLayout";

export default function DostavkaYoybuy() {
  return <ArticleLayout slug="dostavka-yoybuy" />;
}